import React, { forwardRef } from 'react';
import classnames from 'classnames';
import getRenderable from '../../../lib/getRenderable';
import { COLORS } from './constants';
import classes from './index.module.scss';
import { RadioProps } from './types';

/**
 * @deprecated Please use Radio from @fiverr-private/forms instead.
 */
const Radio = forwardRef<HTMLInputElement, RadioProps>(({
    children,
    disabled = false,
    color = 'grey',
    className: customClassName,
    ...rest
}, ref) => {
    const className = classnames(
        classes.radio,
        classes[`color-${color}`],
        {
            [classes.disabled]: disabled
        },
        customClassName
    );
    const inputProps = Object.assign({
        type: 'radio',
        ref,
        disabled
    }, rest);

    return (
        <label className={className}>
            <input {...inputProps}/>
            <span className={classes.circle}/>
            { getRenderable(children) }
        </label>
    );
});

Radio.displayName = 'Radio';

Object.assign(Radio, {
    COLORS
});

export default Radio;
